module.exports = __webpack_public_path__ + "img/byakuren hijiri_lw.91c253d0.png";